import IRule, { IRuleProps } from "./IRule";

interface IRuleRequired extends IRuleProps {
    required: boolean;
}

/**
 * 校验是否必须
 */
class RuleRequired implements IRule {
    type: "required";

    props: IRuleRequired;

    constructor(props: IRuleRequired) {
        this.props = props;
    }

    exec() {
        if (!this.props.required) return false;
        return { required: true, message: this.props.message || "该项为必填项" };
    }
}

export default RuleRequired;
